import { createStore, applyMiddleware } from 'redux';
import middlewares from './middlewares';
import reducers from './reducers';
import type { Brand, Country, Language } from '@seek/melways-sites';
import type { ApiInterface } from './modules/api';
import type { Zone } from '@seek/audience-zones';

export default (
  siteCountry: Country,
  brand: Brand,
  language: Language,
  zone: Zone,
  api: ApiInterface,
) => {
  const middlewareList = middlewares(siteCountry, brand, language, zone, api);

  const createStoreWithMiddleware = applyMiddleware(...middlewareList)(
    createStore,
  );

  return createStoreWithMiddleware(
    reducers,
    typeof window !== 'undefined' &&
      window.__REDUX_DEVTOOLS_EXTENSION__ &&
      window.__REDUX_DEVTOOLS_EXTENSION__(),
  );
};
